import { CommonModule, formatDate } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbOffcanvas, NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ClassroomService } from '../../../../core/services/classroom.service';
import { FileService } from '../../../../core/services/file.service';
import { ProfessorCourseService } from '../../../../core/services/professor-course.service';
import { ProgramService } from '../../../../core/services/program.service';
import { TextbookTaskService } from '../../../../core/services/textbook-task.service';
import { TextbookService } from '../../../../core/services/textbook.service';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { HeaderComponent } from '../../layout/includes/header/header.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-text-book',
    templateUrl: './text-book.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxExtendedPdfViewerModule, NgxPaginationModule],
    styleUrls: ['./text-book.component.css']
})
export class TextBookComponent {
  loading:any
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined

  data:any[] =[]
  textbooks:any[] =[]
  tasks:any[] =[]
  paccs:any[] =[]
  classrooms:any[] =[]
  paccId:any
  tbId:any
  classroomId:any
  current:any
  fileInput:any
  selected_data:any
  currentDate= new Date();
  tag="admin-textbooks"
  pdfViewLoader=false
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  search_text=""
  myDate=null
  pg={
    pageSize:10,
    p:0,
    total:0
  }

  constructor(
    private classroomService:ClassroomService,
    private paccService:ProfessorCourseService,
    private spinnerService:NgxSpinnerService,
    private fileService:FileService,
    private programService:ProgramService,
    private tbService:TextbookService,
    private tbtService:TextbookTaskService,
    private toastrService:ToastrService,
    private offcanvasService: NgbOffcanvas,
    private spinner: NgxSpinnerService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }
  
    ngOnInit(){
  
      this.getAll()
      this.getClassrooms()
    }
  
     
    upload(event:any){
      if (event.target.files.length!=0) {
        this.fileInput=event.target.files[0]
      }
    }
  
    getClassrooms(){
      this.classroomService.getAll().subscribe((res:any)=>{
       this.classrooms=res.data
      },
      (err:any)=>{
        AppErrorShow.showError("Mon cahier de texte",err)

      })
    }
    getPaccs(){
      this.paccService.getAll(this.classroomId).subscribe((res:any)=>{
       this.paccs=res.data
      },
      (err:any)=>{
        AppErrorShow.showError("Mon cahier de texte",err)

      })
    }

    loadPaccs(ev:any){
      this.classroomId=ev

      this.getPaccs()
    }
    getAll(){
      this.spinner.show();
      this.tbService.getAll(this.myDate,this.paccId).subscribe((res:any)=>{
        this.spinner.hide();
       this.data=res.data
        this.pg.pageSize=10
        this.pg.p=0
        this.pg.total=res.data.length
      },
      (err:any)=>{
        this.spinner.hide();
        AppErrorShow.showError("Mon cahier de texte",err)

      })
    }

    reload(ev:any){
      this.myDate=ev.target.value;
      this.getAll()
    }
    reload2(ev:any){
      this.paccId=ev;
      this.getAll()
    }

    checked(el?:any){
      this.selected_data=el;
     // this.is_active=el.is_active
    }
    verifyIfElementChecked(){
      console.log(this.selected_data)
      if (this.selected_data==null) {
        this.toastrService.warning("Aucun élément selectionné");
        return false;
      }
      return true;
    }

    getPage(event:any){
      this.pg.p=event
    }

    edit(content:any,el:any){
      this.selected_data=el
      this.modalService.open(content,{size:'lg'});
  
    }

    loadTextBook(el:any,index?:any){
      if(index!=undefined)this.current=index
      console.log(this.current)
      this.paccId=el.pacc_id
      this.tbService.getByPacc(this.paccId).subscribe((res:any)=>{
        this.textbooks=res.data
      },
      (err:any)=>{
        AppErrorShow.showError("Mon cahier de texte",err)

      })
    }
    loadTextBookTask(id:any){
      this.tbId=id
      this.tbtService.getByTextbook(id).subscribe((res:any)=>{
        this.tasks=res.data
      },
      (err:any)=>{
        AppErrorShow.showError("Mon cahier de texte",err)

      })
    }

    storeTextbook(form:any){
      let formData= new FormData()
      for (const key in form.value) {
        if (Object.prototype.hasOwnProperty.call(form.value, key)) {
          const element = form.value[key];
          formData.append(key,element)
        }
      }
      formData.append('pacc_id',this.paccId)

      if (this.fileInput != undefined) {
        formData.append('filename',this.fileInput)

      }

      this.tbService.store(formData).subscribe((res:any)=>{
        form.resetForm()
        this.loadTextBook(this.paccId)
      },
      (err:any)=>{
        AppErrorShow.showError("Mon cahier de texte",err)

      })
  }
  storeTask(form:any){
      let formData= new FormData()
      for (const key in form.value) {
        if (Object.prototype.hasOwnProperty.call(form.value, key)) {
          const element = form.value[key];
          formData.append(key,element)
        }
      }
      formData.append('textbook_id',this.tbId)

      if (this.fileInput != undefined) {
        formData.append('filename',this.fileInput)

      }

      this.tbtService.store(formData).subscribe((res:any)=>{
        form.resetForm()
        this.loadTextBookTask(this.tbId)
      },
      (err:any)=>{
        AppErrorShow.showError("Mon cahier de texte",err)

      })
  }

  getFile(code:any,folder:any,filename:any,css='details-panel'){
    this.spinnerService.show()
    this.pdfViewLoader=true
    this.fileService.get({
      folder:folder,
      code:code,
      filename:filename
    }).subscribe((res:any)=>{
      this.spinnerService.hide()
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });

    },
    (err:any)=>{
      this.spinner.hide()
      AppErrorShow.showError("Mon cahier de texte",err)

    })
  }

  getDateWithFormat(){
    return formatDate(this.currentDate,'EEE dd LLL','fr_FR')
  }

  previousDate(){
    this.currentDate=new Date(this.currentDate.setDate(this.currentDate.getDate() - 1));
    this.getDateWithFormat()
    this.getAll()

  }
  nextDate(){
    this.currentDate=new Date(this.currentDate.setDate(this.currentDate.getDate() + 1));
    this.getDateWithFormat()
    this.getAll()
  }

  update(value:any){
    this.loading=true

    this.tbService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.modalService.dismissAll()
      this.loading=false
      this.tbService.getByPacc(this.paccId).subscribe((res:any)=>{
        this.textbooks=res.data
      },
      (err:any)=>{
        AppErrorShow.showError("Mon cahier de texte",err)

      })
        this.toastrService.success(res.message)
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des classes apprenants",err)

    })
  }
  update2(value:any){
    this.loading=true

    this.tbtService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.modalService.dismissAll()
      this.loading=false
      this.tbtService.getByTextbook(this.tbId).subscribe((res:any)=>{
        this.tasks=res.data
      },
      (err:any)=>{
        AppErrorShow.showError("Mon cahier de texte",err)

      })
        this.toastrService.success(res.message)
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des classes apprenants",err)

    })
  }

  delete(el:any){
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.tbService.delete(el.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.tbService.getByPacc(this.paccId).subscribe((res:any)=>{
          this.tasks=res.data
        },
        (err:any)=>{
          AppErrorShow.showError("Mon cahier de texte",err)
  
        })
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des classes apprenants",err)

    })
  }
})
  }

  delete2(el:any){
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.tbtService.delete(el.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)

        this.tbtService.getByTextbook(this.tbId).subscribe((res:any)=>{
          this.tasks=res.data
        },
        (err:any)=>{
          AppErrorShow.showError("Mon cahier de texte",err)
  
        })
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des classes apprenants",err)

    })
  }
})
  }
}
